import styled from 'styled-components'
import { BP } from 'resources/constants'

export const Container = styled.div`
  display: flex;
  width: 290px;
  position: relative;

  @media (max-width: ${BP.xs.max}) {
    width: 100%;
    margin-top: 15px;
  }

  > button {
    position: absolute;
    right: 7px;
    top: 6px;
    bottom: 5px;
    font-weight: bold;
    padding: 2px;
    border: none;
    color: ${props => props.theme.palette.general.light};
    background-color: ${props => props.theme.palette.primary.alphaDark};
    width: 28px;
    height: 28px;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    svg {
      width: 15px;
      height: 20px;
      fill: ${props => props.theme.palette.general.light};
    }
  }

  input {
    width: 100%;
    height: 40px;
    border-radius: 3px;
    border: 1px solid ${props => props.theme.palette.general.greyDark};
    padding: 7px 15px;

    &:focus {
      outline: 0;
    }
  }
`
